import { schema, types } from 'papr'

const AVAILABLE_TYPES = ['SAVED' as const, 'ANSWER_LATER' as const]
const AVAILABLE_ITEM_TYPES = [
	'link' as const,
	'story' as const,
	'question' as const,
	'response' as const,
]

export const bookmarkSchema = schema(
	{
		bookmarkType: types.enum(AVAILABLE_TYPES, { required: true }),
		owner: types.objectId({ required: true }),
		post: types.objectId({ required: true }),
		responseId: types.string(),
		dateAdded: types.date({ required: true }),
		isActive: types.boolean({ required: true }),
		itemType: types.enum(AVAILABLE_ITEM_TYPES),
	},
	{
		defaults: {
			isActive: true,
		},
	},
)

export type BookmarkDocument = (typeof bookmarkSchema)[0]
export type BookmarkSchemaOptions = (typeof bookmarkSchema)[1]
